import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateStorageService } from 'app/core/auth/state-storage.service';
import { accountFeature } from 'app/travomate/store/account/account.state';

@Injectable({ providedIn: 'root' })
export class TravomateStateStorageService extends StateStorageService {
  private store = inject(Store);
  private user = this.store.selectSignal(accountFeature.selectCurrentUser);

  getAuthenticationToken(): string | null {
    const username = this.user()?.username;
    if (username) {
      for (let index = 0; index < localStorage.length; index++) {
        const accessTokenKey = localStorage.key(index);
        if (accessTokenKey?.endsWith(username + '.accessToken')) {
          return localStorage.getItem(accessTokenKey);
        }
      }
    }
    return null;
  }
}
